export default function BrandDirection() {
  return (
    <section id="brand" className="py-24 bg-white relative overflow-hidden">
      {/* 배경 장식 */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-orange-200 rounded-full blur-3xl opacity-20"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-orange-100 rounded-full blur-3xl opacity-25"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">브랜드 방향성</h2>
          <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
        </div>
        
        <div className="max-w-5xl mx-auto">
          {/* 브랜드 철학 - 이미지와 함께 */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
            <div className="order-2 lg:order-1">
              <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl p-12 text-white shadow-2xl">
                <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-6">
                  <i className="ri-lightbulb-line text-4xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold mb-6">브랜드 철학</h3>
                <p className="text-xl leading-relaxed">
                  무엇을 하느냐보다<br />
                  어떻게 머무느냐를 중요하게 생각합니다.
                </p>
              </div>
            </div>
            
            <div className="order-1 lg:order-2 relative">
              <div className="absolute inset-0 bg-gradient-to-br from-orange-400 to-orange-500 rounded-3xl transform -rotate-3"></div>
              <img 
                src="https://public.readdy.ai/ai/img_res/2b230fcee02f7364596f8ee120b498eb.jpg"
                alt="브랜드 철학"
                className="relative rounded-3xl shadow-2xl w-full h-[350px] object-cover"
              />
            </div>
          </div>
          
          {/* 운영 방향 */}
          <div>
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-4">운영 방향</h3>
              <p className="text-lg text-gray-600">PLAY PLACE만의 차별화된 운영 전략</p>
            </div>
            
            <div className="grid md:grid-cols-3 gap-10">
              <div className="group bg-white rounded-2xl p-10 shadow-lg border-t-4 border-orange-500 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
                <div className="relative mb-8">
                  <div className="w-24 h-24 mx-auto">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20space%20management%20concept%20illustration%2C%20clean%20organized%20interior%2C%20efficient%20layout%20design%2C%20simple%20geometric%20shapes%2C%20orange%20accent%20colors%2C%20professional%20business%20illustration%20style%2C%20bright%20and%20clear&width=200&height=200&seq=operation-direction-1&orientation=squarish"
                      alt="공간 중심 운영"
                      className="w-full h-full object-cover rounded-2xl"
                    />
                  </div>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4 text-center whitespace-nowrap">공간 중심 운영</h4>
                <p className="text-gray-600 text-center leading-relaxed">공간을 중심으로 한<br />효율적인 운영 구조</p>
              </div>
              
              <div className="group bg-white rounded-2xl p-10 shadow-lg border-t-4 border-orange-500 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
                <div className="relative mb-8">
                  <div className="w-24 h-24 mx-auto">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Open%20door%20welcoming%20entrance%20concept%2C%20accessible%20friendly%20environment%2C%20inclusive%20space%20design%2C%20warm%20inviting%20atmosphere%2C%20modern%20minimalist%20illustration%2C%20orange%20accent%20colors%2C%20professional%20style%2C%20bright%20and%20welcoming&width=200&height=200&seq=operation-direction-2&orientation=squarish"
                      alt="참여 장벽 최소화"
                      className="w-full h-full object-cover rounded-2xl"
                    />
                  </div>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4 text-center whitespace-nowrap">참여 장벽 최소화</h4>
                <p className="text-gray-600 text-center leading-relaxed">누구나 쉽게 참여할 수 있는<br />접근성</p>
              </div>
              
              <div className="group bg-white rounded-2xl p-10 shadow-lg border-t-4 border-orange-500 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
                <div className="relative mb-8">
                  <div className="w-24 h-24 mx-auto">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Time%20and%20comfort%20concept%20illustration%2C%20relaxing%20peaceful%20environment%2C%20comfortable%20seating%20area%2C%20cozy%20atmosphere%2C%20modern%20interior%20design%2C%20orange%20warm%20tones%2C%20professional%20illustration%20style%2C%20inviting%20and%20calm&width=200&height=200&seq=operation-direction-3&orientation=squarish"
                      alt="체류 시간 중심 설계"
                      className="w-full h-full object-cover rounded-2xl"
                    />
                  </div>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4 text-center whitespace-nowrap">체류 시간 중심 설계</h4>
                <p className="text-gray-600 text-center leading-relaxed">머무는 시간 자체가<br />가치가 되는 공간</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}